import { useLocation } from "react-router-dom";

import "url-search-params-polyfill";

export function useQuery() {
  const { search } = useLocation();
  return new URLSearchParams(search);
}
